module.exports = __webpack_public_path__ + "img/footer_bg.d5c1a470.png";